import * as React from 'react';

const PurchaseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    fill="none"
    viewBox="0 0 14 15"
  >
    <path
      fill="#595D70"
      fillRule="evenodd"
      stroke="#595D70"
      strokeWidth="0.162"
      d="M3.602 7.641v2.333c0 .43.346.778.776.778h5.767c.43.162.775-.348.775-.778V7.641h.791v2.333c0 .86-.707 1.718-1.566 1.556H4.378c-.86 0-1.551-.696-1.551-1.556V7.641zm3.275.068V2.035h.778V7.71l1.679-1.677a.38.38 0 0 1 .537 0c.15.152.15.395 0 .545l-2.605 2.62-2.612-2.619a.385.385 0 0 1 .545-.545z"
      clipRule="evenodd"
    ></path>
  </svg>
);
export default PurchaseSvg;
